/* storybook-check-ignore */
import { Accordion, Box, Image, Text } from '@opendoor/bricks-next';

export const BuyWithConfidence = () => {
  const title = 'Buy with peace of mind';
  const description = (
    <Box justifyContent="space-between" flexDirection="column" width="100%" gap="$12x">
      <Box
        backgroundColor="$backgroundSecondary"
        padding="$12x"
        borderRadius="$6x"
        alignItems="flex-start"
        flexDirection="column"
        gap="$12x"
      >
        <Image
          source={{
            height: 50,
            uri: 'https://images.opendoor.com/source/s3/imgdrop-production/2025-10-1759356984907-52934.png?preset=square-2048',
            width: 50,
          }}
          alt="7 day money back guarantee badge"
        />
        <Text tag="p" typography="$bodyMedium" color="$contentPrimary" fontWeight="$medium">
          7-Day Home Test Drive
        </Text>
        <Text tag="p" typography="$bodyMedium" color="$contentPrimary">
          We want you to love your new home. Move in 7 days early to experience the space, the
          neighborhood, and the lifestyle. If you don’t love it, simply walk away.
        </Text>
      </Box>
      <Box
        backgroundColor="$backgroundSecondary"
        padding="$12x"
        borderRadius="$6x"
        alignItems="flex-start"
        flexDirection="column"
        gap="$12x"
      >
        <Image
          source={{
            height: 50,
            uri: 'https://images.opendoor.com/source/s3/imgdrop-production/2025-09-1758841076305-88590.png?preset=square-2048',
            width: 50,
          }}
          alt="peace of mind promise badge"
        />
        <Text tag="p" typography="$bodyMedium" color="$contentPrimary" fontWeight="$medium">
          100-Day Warranty
        </Text>
        <Text tag="p" typography="$bodyMedium" color="$contentPrimary">
          Every Opendoor home comes standard with 100 days of protection on your home’s major
          systems and appliances.
        </Text>
      </Box>
    </Box>
  );

  return (
    <>
      <Box
        $smallerThanLG={{ display: 'none' }}
        data-testid="marketplace-buy-with-confidence-accordion-desktop"
        width="100%"
      >
        <Accordion
          items={[
            {
              title,
              description,
            },
          ]}
          variant="medium"
          size="xlarge"
          isFullWidth
          defaultOpen
        />
      </Box>
      <Box
        $largerThanMD={{ display: 'none' }}
        data-testid="marketplace-buy-with-confidence-accordion-mobile"
        width="100%"
      >
        <Accordion
          items={[
            {
              title,
              description,
            },
          ]}
          variant="medium"
          size="large"
          isFullWidth
          defaultOpen
        />
      </Box>
    </>
  );
};
